import angular from 'angular';

import leadPopupModule from '../lead.popup/lead.popup.module';
import unitPopupModule from '../unit.popup/unit.popup.module';
import { routesConfig } from './appeals.routes';

export default angular
  .module('appeals', [
    unitPopupModule.name,
    leadPopupModule.name,
    'isteven-multi-select',
    'cloudinary',
  ])
  .config(routesConfig);
